import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({
	providedIn: 'root'
})
export class PermissionsService {

	route = '/permissions/';

	constructor(
		private httpClient: HttpClient
	) { }

	getPermissionsList(type) {
		return this.httpClient.get(this.route + 'getPermissionsList', {
			params: { type },
			observe: "body"
		});
	}

	getPermissionInfo(permissionId, type) {
		return this.httpClient.get(this.route + 'getPermissionInfo', {
			params: { permissionId, type },
			observe: "body"
		});
	}

	addPermission(options) {
		return this.httpClient.post(this.route + 'addPermission', options, {
			observe: "body"
		});
	}

	updatePermission(options) {
		return this.httpClient.put(this.route + 'updatePermission', options, {
			observe: "body"
		});
	}

	deletePermission(options) {
		return this.httpClient.delete(this.route + 'deletePermission', {
			body: options,
			observe: "body"
		});
	}
}
